import { HttpClient } from '@wix/http-client';
import { WIX_META_SITE_ID_HEADER } from 'config/consts';

const baseURL = window.location.origin + window.__BASEURL__;

const getHeadersWithMetaSiteId = () => ({
  [WIX_META_SITE_ID_HEADER]: window.__META_SITE_ID__,
});

const client = new HttpClient({ baseURL, headers: getHeadersWithMetaSiteId() });

const ambassador = new HttpClient({ headers: getHeadersWithMetaSiteId() });

export const httpUtils = {
  client,
  ambassador,
  getHeadersWithMetaSiteId,
};
